module.exports = __webpack_public_path__ + "img/img_banner_project_0.78c1a592.jpg";